import ResetPassword from './ResetPassword.vue'

export default ResetPassword
